import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  ContextMenu,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { getValue } from '@syncfusion/ej2-base';
import { all_information, loadingShow } from '../../../App';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import Message from '../../../utils/Message/Message';
import { ThemeContext } from '../../../context/theme.context';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import ReactDOM from 'react-dom';
import {
  AddShiftWorkbench,
  DeleteShiftWorkbench,
  EditShiftWorkbench,
  getShiftWorkbench,
} from '../../../services/ShiftWorkbench/ShiftWorkbenchService';
import { getShiftWorkbenchSettings } from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import ShiftWorkbench from '../Shiftworkbench';
import { getElementAlias } from '../../../services/Settings/ElementAlias';
import { getTeams } from '../../../services/tradeperson/team';

interface IProps {}
interface IState {
  WorkbenchData: Array<any>;
  SupervisorData: Array<any>;
  SiteData: Array<any>;
  LocationData: Array<any>;
  ElementAliasData: Array<any>;
  TeamsData: Array<any>;
  WorkbencStatusData: Array<any>;
  detailsDialog: boolean;
  workbench_id: number;
  trans_date: Date;
  workbench_data: any;
}
export default class Summary extends Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: 'Top',
  };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Complete',
      tooltipText: 'Complete',
      prefixIcon: 'e-save',
      id: 'complete',
    },
    'ColumnChooser',
    'ExcelExport',
    {
      text: 'Preview',
      tooltipText: 'Preview',
      prefixIcon: 'e-success',
      id: 'preview',
    },
    'Search',
  ];
  public validationRule: Object = { required: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private animationSettings: AnimationSettingsModel;
  private buttonsForWorkbench: ButtonPropsModel[];

  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public contextMenuItems = [
    {
      text: 'Navigate to Workbench',
      tooltipText: 'view',
      prefixIcon: 'e-view',
      id: 'view',
    },
  ];
  private fieldSupervisor: object = {
    text: 'supervisor_name',
    value: 'id',
  };
  private fieldSites: object = {
    text: 'site_name',
    value: 'id',
  };
  private fieldLocation: object = {
    text: 'department_name',
    value: 'id',
  };
  private fieldAlias: object = {
    text: 'element_alias_name',
    value: 'element_alias_id',
  };
  private fieldTeams: object = {
    text: 'team_code',
    value: 'team_id',
  };
  private fieldWorkbenchStatus: object = {
    text: 'status_alias',
    value: 'id',
  };
  private weekday = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  private dropDownListObjectElementAlias: any;
  private dropDownListObjectTeam: any;
  private dropDownListObjectLocation: any;
  private dropDownListObjectSite: any;
  private dropDownListObjectSuppervisor: any;
  private dropDownListObjectWorkbenchStatusData: any;
  private gridWorkbenchSummaryObj: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      WorkbenchData: [],
      SupervisorData: [],
      SiteData: [],
      TeamsData: [],
      LocationData: [],
      ElementAliasData: [],
      WorkbencStatusData: [],
      detailsDialog: false,
      workbench_id: -1,
      trans_date: new Date(),
      workbench_data: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsForWorkbench = [
      {
        click: () => {
          this.setState({ detailsDialog: false });
        },
        buttonModel: {
          content: 'Done',
          isPrimary: true,
        },
      },
    ];
  }
  async getWorkbenchStatus() {
    getShiftWorkbenchSettings('workbenchstatus').then((res) => {
      this.setState({ WorkbencStatusData: res.data });
    });
  }
  async getWorkbench() {
    await getShiftWorkbench('workbench')
      .then((res) => {
        let model = res.data.map((item: any) => {
          return {
            ...item,
            day: this.getDay(item.day),
          };
        });
        this.setState({ WorkbenchData: model });
      })
      .catch((e: any) => {
        //(e);
      });
  }
  getDay(day: any) {
    let incomingDay = day === 0 ? 7 : day;
    return this.weekday[incomingDay - 1];
  }
  convertDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = new Date(num);
    return date;
  }
  async getTeams() {
    await getTeams().then((res) => {
      this.setState({ TeamsData: res.data });
    });
  }
  async getWorkbenchSupervisor() {
    await getShiftWorkbenchSettings('supervisor').then((res) => {
      this.setState({ SupervisorData: res.data });
    });
  }
  async getWorkbenchSites() {
    await getShiftWorkbenchSettings('sites').then((res) => {
      this.setState({ SiteData: res.data });
    });
  }
  async getWorkbenchLocation() {
    await getShiftWorkbenchSettings('department').then((res) => {
      let model = res.data.map((item: any) => {
        return {
          ...item,
        };
      });
      this.setState({ LocationData: model });
    });
  }
  async getWorkbenchElementAlias() {
    await getElementAlias(true).then((res) => {
      this.setState({ ElementAliasData: res.data });
    });
  }
  private async toolbarClick(args: any) {
    if (args.item.id === 'complete') {
      let data = this.gridWorkbenchSummaryObj.getSelectedRecords();
      let find = this.state.WorkbencStatusData.find((x: any) =>
        x.status_alias.includes('Comp')
      );
      if (find === undefined) {
        Message.error('Completed status not found!');
        return false;
      }
      if (data.length > 0) {
        let allData: any = [];
        await data.map((item: any) => {
          var date = '/Date(' + new Date(item.date).getTime() + '-0500' + ')/';
          const obj = {
            app: 'app',
            organization_id: all_information.company_id?.toString(),
            supervisor_id: item.supervisor_id,
            date: date,
            day: new Date(item.date).getDay(),
            team_id: item.team_id,
            element_alias_id: item.element_alias_id,
            site_id: item.site_id,
            location_id: item.location_id,
            workbench_status_id: find.id,
            user_id: all_information.user_id,
            issue: '',
            actions: '',
            cause: '',
            id: item.id,
          };
          allData.push(obj);
        });
        let obje = {
          BulkWorkbenchDtos: allData,
        };
        EditShiftWorkbench(obje)
          .then((res: any) => {
            Message.success('Success');
            loadingShow(false);
            this.getWorkbench();
          })
          .catch((err: any) => {
            if (err.response) {
              Message.error(
                err.response.data +
                  '\n' +
                  err.response.status +
                  '\n' +
                  err.response.headers
              );
            } else if (err.request) {
              Message.error(err.request);
            } else {
              Message.error('Error: ' + err.message);
            }
            loadingShow(false);
          });
      } else {
        Message.error('Please select a record!');
        return false;
      }
    }
    if (args.item.id === 'refresh') {
      this.getWorkbench();
    }
    if (args.item.id === 'preview') {
      let data = this.gridWorkbenchSummaryObj.getSelectedRecords();
      if (data.length > 0) {
        this.callTheDetailScreen(data[0]);
      } else {
        Message.error('Please select a record!');
        return false;
      }
    }
    if (
      this.gridWorkbenchSummaryObj &&
      args.item.id === 'gridWorkbenchSummary_excelexport'
    ) {
      this.gridWorkbenchSummaryObj.excelExport();
    }
  }
  async componentDidMount() {
    loadingShow(true);
    await this.getWorkbench();
    this.getWorkbenchSupervisor();
    this.getWorkbenchSites();
    this.getWorkbenchLocation();
    this.getWorkbenchElementAlias();
    this.getTeams();
    this.getWorkbenchStatus();
    loadingShow(false);
  }
  private SupervisorTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='SuperVisor'
        text={args.supervisor_name}
        value={args.supervisor_id}
        dataSource={this.state.SupervisorData}
        ref={(scope) => (this.dropDownListObjectSuppervisor = scope)}
        fields={this.fieldSupervisor}
      />
    );
  }
  private WorkbenchStatusTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Status'
        value={args.workbench_status_id}
        text={args.status_code}
        dataSource={this.state.WorkbencStatusData}
        itemTemplate={this.itemTemplateWorkbenchStatusColor.bind(this)}
        ref={(scope) => (this.dropDownListObjectWorkbenchStatusData = scope)}
        fields={this.fieldWorkbenchStatus}
      />
    );
  }
  private itemTemplateWorkbenchStatusColor(data: any): JSX.Element {
    return (
      <span
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          paddingLeft: '5px',
        }}
      >
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.status_color }}
        ></span>
        <span>{data.status_alias}</span>
      </span>
    );
  }
  private SiteTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Sites'
        text={args.site_name}
        value={args.site_id}
        dataSource={this.state.SiteData}
        ref={(scope) => (this.dropDownListObjectSite = scope)}
        fields={this.fieldSites}
      />
    );
  }
  private LocationTemplateEditin(args: any) {
    return (
      <DropDownListComponent
        placeholder='Location'
        text={args.location_name}
        value={args.location_id}
        dataSource={this.state.LocationData}
        ref={(scope) => (this.dropDownListObjectLocation = scope)}
        fields={this.fieldLocation}
      />
    );
  }
  private ElementAliasTemplateEditin(args: any) {
    return (
      <DropDownListComponent
        placeholder='Shift'
        text={args.element_alias_name}
        value={args.element_alias_id}
        dataSource={this.state.ElementAliasData}
        ref={(scope) => (this.dropDownListObjectElementAlias = scope)}
        fields={this.fieldAlias}
      />
    );
  }
  private TeamsTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Teams'
        text={args.team_code}
        value={args.team_id}
        dataSource={this.state.TeamsData}
        ref={(scope) => (this.dropDownListObjectTeam = scope)}
        fields={this.fieldTeams}
      />
    );
  }
  actionBeginSummary(args: any) {
    if (args.action === 'add') {
      this.savePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.savePointEdit(args.data);
    }
  }
  savePointAdd(data: any) {
    let team = this.dropDownListObjectTeam.value;
    let supervisor = this.dropDownListObjectSuppervisor.value;
    let location = this.dropDownListObjectLocation.value;
    let elementAlias = this.dropDownListObjectElementAlias.value;
    let site = this.dropDownListObjectSite.value;
    let workbench_status = this.dropDownListObjectWorkbenchStatusData.value;

    if (team === undefined || team === null) {
      Message.error('Can not be empty Teams');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }
    if (supervisor === undefined || supervisor === null) {
      Message.error('Can not be empty Supervisor');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }
    if (site === undefined || site === null) {
      Message.error('Can not be empty Site');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }
    if (location === undefined || location === null) {
      Message.error('Can not be empty Location');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }
    if (elementAlias === undefined || elementAlias === null) {
      Message.error('Can not be empty Shift');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }
    if (workbench_status === undefined || workbench_status === null) {
      Message.error('Can not be empty Status');
      this.gridWorkbenchSummaryObj.refresh();
      return false;
    }

    loadingShow(true);
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      supervisor_id: supervisor,
      date: data.date,
      day: new Date(data.date).getDay(),
      team_id: team,
      element_alias_id: elementAlias,
      site_id: site,
      location_id: location,
      workbench_status_id: workbench_status,
      user_id: all_information.user_id,
      issue: '',
      actions: '',
      cause: '',
      unit: 'workbench',
    });
    //(obj);

    AddShiftWorkbench(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbench();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEdit(data: any) {
    let team = this.dropDownListObjectTeam.value;
    let supervisor = this.dropDownListObjectSuppervisor.value;
    let location = this.dropDownListObjectLocation.value;
    let elementAlias = this.dropDownListObjectElementAlias.value;
    let site = this.dropDownListObjectSite.value;
    let workbench_status = this.dropDownListObjectWorkbenchStatusData.value;
    loadingShow(true);
    let array = new Array();
    const obj = {
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      supervisor_id: supervisor,
      date: data.date,
      day: new Date(data.date).getDay(),
      team_id: team,
      element_alias_id: elementAlias,
      site_id: site,
      location_id: location,
      workbench_status_id: workbench_status,
      user_id: all_information.user_id,
      issue: '',
      actions: '',
      cause: '',
      id: data.id,
      unit: 'workbench',
    };
    array.push(obj);
    let obje = [...array];
    EditShiftWorkbench(obje)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbench();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }

  contextMenuClick(args: any) {
    if (args.item.id === 'view') {
      let data = args.rowInfo.rowData;
      //burda summary tabindan workbench tabina geçmek için Event için yapılan contexti kullanıyorum
      if (data !== undefined) {
        this.callTheDetailScreen(data);
      }
    }
  }
  private workbencIdEditTemplate(args: any) {
    return <TextBoxComponent disabled value={args.id} />;
  }
  private workbenchDayEditTemplate(args: any) {
    return <TextBoxComponent disabled value={args.day} />;
  }
  private callTheDetailScreen = (data: any) => {
    if (data?.id) {
      this.setState({
        detailsDialog: true,
        workbench_id: data?.id,
        trans_date: data?.date,
        workbench_data: data,
      });
    }
  };
  private handleBeforeClose = (args: any) => {
    if (args.closedBy !== 'close icon') {
      args.cancel = true;
    }
  };
  render() {
    return (
      <div>
        <GridComponent
          id='gridWorkbenchSummary'
          dataSource={this.state.WorkbenchData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridWorkbenchSummaryObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={false}
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          allowExcelExport={true}
          showColumnChooser
          enablePersistence
          allowResizing={true}
          allowGrouping={true}
          gridLines='Both'
          height={'calc(-200px + 100vh)'}
          contextMenuItems={this.contextMenuItems}
          contextMenuClick={this.contextMenuClick.bind(this)}
          actionBegin={this.actionBeginSummary.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective type='checkbox' />
            <ColumnDirective
              field='id'
              headerText='Shift Workbench ID'
              isPrimaryKey={true}

              //  editTemplate={this.workbencIdEditTemplate.bind(this)}
            />
            <ColumnDirective
              field='date'
              validationRules={this.validationRule}
              editType='datepickeredit'
              headerText='Transaction Date'
              format='dd/MM/yyyy'
              isPrimaryKey={true}
            />
            <ColumnDirective
              field='day'
              headerText='Day'
              editTemplate={this.workbenchDayEditTemplate.bind(this)}
            />
            <ColumnDirective
              field='team_code'
              headerText='Teams'
              editType='dropdownedit'
              editTemplate={this.TeamsTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='element_alias_name'
              headerText='Shift'
              editType='dropdownedit'
              editTemplate={this.ElementAliasTemplateEditin.bind(this)}
            />
            <ColumnDirective
              field='supervisor_name'
              //  validationRules={this.validationRule}
              headerText='Supervisor'
              editType='dropdownedit'
              editTemplate={this.SupervisorTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='site_name'
              headerText='Site'
              editType='dropdownedit'
              editTemplate={this.SiteTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='location_name'
              headerText='location'
              editType='dropdownedit'
              editTemplate={this.LocationTemplateEditin.bind(this)}
            />
            <ColumnDirective
              field='status_alias'
              headerText='Status'
              editType='dropdownedit'
              template={this.itemTemplateWorkbenchStatusColor.bind(this)}
              editTemplate={this.WorkbenchStatusTemplateEditing.bind(this)}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              ContextMenu,
              Filter,
              ColumnMenu,
              Resize,
              Toolbar,
              ColumnChooser,
              ExcelExport,
              Page,
              Group,
            ]}
          />
        </GridComponent>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.detailsDialog ? (
              <DialogComponent
                isModal={true}
                id='modalSummaryDelete'
                animationSettings={{
                  delay: 1,
                  duration: 500,
                  effect: 'FadeZoom',
                }}
                showCloseIcon={true}
                visible={this.state.detailsDialog}
                width={'98%'}
                height={'90vh'}
                buttons={this.buttonsForWorkbench}
                open={() => {
                  // this.setState({ detailsDialog: true });
                }}
                close={() => {
                  this.setState({ detailsDialog: false });
                }}
                beforeClose={this.handleBeforeClose.bind(this)}
                content={() => (
                  <ShiftWorkbench
                    workbench_id={this.state.workbench_id}
                    trans_date={this.state.trans_date}
                    workbench_data={this.state.workbench_data}
                  />
                )}
              ></DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
